import React from "react";

// Components
import Nav from "../../comps/Nav";
import Home from "../../comps/Home";

const App = () => {

    return (

        <div className="App">

            <Nav />

            <Home />

        </div>

    );

}

export default App;
